/* Rug Plan modal chrome — open/close + post-submit reopen.
   The form INSIDE the dialog is fully driven by the shared
   jubi-rug-plan.js (uploads, Klaviyo, source field); this file only:
     1. opens the dialog from any [data-rug-plan-open] trigger
        (preventDefault — the trigger's /pages/rug-plan href stays as
        the no-JS fallback) and stamps contact[Source] from the
        trigger's ?src= param;
     2. closes on ×, Esc, and backdrop click;
     3. after the native POST round-trip, detects Shopify's redirect
        fragment (#JubiRugPlanModal = the form id) and auto-reopens
        showing the server-rendered success or errors. The hash gate
        means another contact form posting elsewhere on the site can
        never pop this modal. */
(function () {
  'use strict';

  var FORM_HASH = '#JubiRugPlanModal';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var dialog = document.getElementById('JubiRugPlanModalDialog');
    if (!dialog || typeof dialog.showModal !== 'function') { return; }

    var body = dialog.querySelector('[data-jrpm-body]');
    var success = dialog.querySelector('[data-jrpm-success]');
    var sourceField = dialog.querySelector('[data-jrp-source]');

    function open() {
      if (dialog.open) { return; }
      dialog.showModal();
      document.body.classList.add('jrpm-open');
    }

    function close() {
      if (dialog.open) { dialog.close(); }
    }

    dialog.addEventListener('close', function () {
      document.body.classList.remove('jrpm-open');
    });

    /* Backdrop click = click lands on the dialog element itself */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) { close(); }
    });

    var closeBtn = dialog.querySelector('[data-jrpm-close]');
    if (closeBtn) { closeBtn.addEventListener('click', close); }

    /* ---- Post-submit reopen ---------------------------------- */
    var postedHere = window.location.hash === FORM_HASH;
    if (postedHere && (success || dialog.querySelector('.jrp__form-error'))) {
      /* Strip the fragment so reloads/anchor-scrolls don't replay it */
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } catch (err) { /* ignore */ }
      open();
      var focusTarget = success || dialog.querySelector('.jrp__form-error');
      try { focusTarget.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
    } else if (success && body) {
      /* posted_successfully leaked from ANOTHER contact form on this
         page (Shopify sets it per form type, not per form) — a fresh
         trigger click should show the form, not a stale success. */
      success.hidden = true;
      body.classList.remove('jrpm__body--hidden');
    }

    /* ---- Triggers --------------------------------------------- */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-rug-plan-open]');
      if (!trigger) { return; }
      e.preventDefault();

      /* Carry the trigger's src tag into the email's Source line
         (and, via the shared JS, the Klaviyo Request Source). */
      if (sourceField) {
        var src = '';
        try {
          var href = trigger.getAttribute('href') || '';
          var q = href.split('?')[1] || '';
          src = new URLSearchParams(q).get('src') || '';
        } catch (err) { /* ignore */ }
        sourceField.value = src || 'modal';
      }

      /* PDP triggers carry the product they were viewing — stamp it into
         the submission (disabled = line omitted when no context). The
         trigger also carries an id→title map of the product's variants,
         so the email records the colorway/size selected at open time. */
      var viewing = dialog.querySelector('[data-jrpm-viewing]');
      var productContext = '';
      var displayContext = '';
      if (viewing) {
        productContext = trigger.getAttribute('data-rug-plan-product') || '';
        displayContext = productContext.split(' — ')[0];
        var vmapAttr = trigger.getAttribute('data-rug-plan-variants');
        if (productContext && vmapAttr) {
          try {
            var vmap = JSON.parse(vmapAttr);
            var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]') ||
                       document.querySelector('[name="id"]');
            var vtitle = idEl && vmap[String(idEl.value)];
            if (vtitle && vtitle !== 'Default Title') {
              productContext = productContext.replace(' — ', ' (' + vtitle + ') — ');
              displayContext += ' — ' + vtitle;
            }
          } catch (err) { /* map optional */ }
        }
        viewing.value = productContext;
        viewing.disabled = !productContext;
      }

      /* Rug mode: the whole form re-frames around the chosen rug —
         heading/intro swap, prominent planning-around block, and the
         questions the PDP already answered (style, budget) drop out.
         Generic openings restore the suggest-me copy and full form. */
      var rugMode = !!productContext;
      ['[data-jrpm-heading]', '[data-jrpm-intro]'].forEach(function (sel) {
        var el = dialog.querySelector(sel);
        if (el) {
          el.textContent = el.getAttribute(rugMode ? 'data-rug-mode' : 'data-generic');
        }
      });
      var contextBlock = dialog.querySelector('[data-jrpm-context]');
      var contextName = dialog.querySelector('[data-jrpm-context-name]');
      if (contextBlock && contextName) {
        contextName.textContent = displayContext;
        contextBlock.hidden = !displayContext;
      }
      ['Style', 'Budget'].forEach(function (fieldName) {
        var sel = dialog.querySelector('select[name="contact[' + fieldName + ']"]');
        if (sel) {
          sel.disabled = rugMode;
          var wrap = sel.closest('label');
          if (wrap) { wrap.hidden = rugMode; }
        }
      });

      open();
      var firstInput = dialog.querySelector('input[name="contact[Name]"]');
      if (firstInput && body && !body.classList.contains('jrpm__body--hidden')) {
        try { firstInput.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
      }
    });
  });
})();
